import "../styles/layout.css"
import Layout from "./Layout"
function BookLoading() {
    return (
        <Layout>
            <div className="book-skeleton">
                <div className="skeleton cover" />
                <div className="skeleton title" />
                <div className="skeleton text" />
                <div className="skeleton button" />
            </div>
        </Layout>
    )
}

export default BookLoading